<!-- 预订页面 -->
<template>
  <div class='book_wrap'>
    <!-- 商品选择 -->
    <div class="product_info_wrap">
      <!-- 商品信息 -->
      <div class="product_info_body">
        <div
          class="prod_left_wrap"
          v-lazy:background-image="`${apiObj.VUE_APP_BASE_CDN + infos.cover}`"
        >
          <!-- v-lazy:background-image="`${apiObj.VUE_APP_BASE_CDN + infos.cover + '!/fh/80'}`" -->
        </div>
        <div class="prod_right_wrap">
          <div class="room_name">{{infos.room_name}}</div>
          <div class="hotel_name">{{infos.hotel_name}}</div>
          <div class="prod_right_footer">
            <div class="prod_footer_left">
              <div class="check_time">{{$t('book.checkIn')}}：{{infos.checkin}}</div>
              <div class="check_time">{{$t('book.checkOut')}}：{{infos.checkout}}</div>
            </div>
            <div class="prod_footer_right">
              <div class="check_days">{{$t('book.total')}} {{days}} {{$t('book.night')}}</div>
              <div class="good_name">{{infos.good_name}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 选择数量 -->
      <div class="stepper_wrap">
        <div class="stepper_text">{{infos.type ? $t('book.bedNum') : $t('book.roomNum')}}</div>
        <div class="stepper_body">
          <van-stepper
            v-model="goodnum"
            disable-input
            :max="max_buy_quantity == 0 ? '999999' : max_buy_quantity"
          />
        </div>
      </div>
      <!-- 分割线 -->
      <van-divider />
    </div>
    <CusTitle :text="$t('book.formTitle')" />
    <!-- 表单信息 -->
    <div class="form_info_wrap">
      <GoodForm
        :formOptions="formOptions"
        :fieldsData="fieldsData"
        :isSubmit="isSubmit"
        @listenResetSubmitStatus="resetSubmitStatus"
        @listenformDataCheckFinish="formDataCheckFinish"
      />
    </div>

    <!-- 分隔 -->
    <div
      v-show="is_bottom_text"
      class="divider_wrap"
    >
      <van-divider />
    </div>
    <!-- 售卖政策 -->
    <CusTitle
      v-show="is_bottom_text"
      :text="$t('book.saleTitle')"
    />
    <div
      v-show="is_bottom_text"
      class="sale_intro_wrap"
    >
      <RichText :info="bottom_text" />
    </div>

    <!-- 版权 -->
    <CopyRight v-show="this.$root.isVersion" />

    <!-- 底部按钮 -->
    <BookFooter
      :currency="currency"
      :number="goodnum"
      :days="days"
      :price="infos.price"
      :issubmit="submiting"
      @listenwannaBookRoom="wannaBookRoom"
    />

    <!-- 支付方式选择 -->
    <PaymentWay
      :payment="payment"
      :show="ispayment"
      :offlinetext="offline_pay_text"
      :isuploadcert="is_offline_pay_cert"
      @listenClosePickPaymentMethod="closePaymentPicker"
      @listenPickedPaymentWay="pickedPaymentWay"
    />

    <!-- 加载 -->
    <CusLoading :show="loading" />
    <!-- 未支付订单 -->
    <CusPayAgain
      :show="isnopaid"
      :orderno="waitOrder"
      :payment="waitPayway"
      :payment_method="waitPayMethod"
      @listenCloseDialog="closeDialog"
      @listenAlipayInWechat="alipayInWechat"
    />
    <BackBtn />

    <!-- 支付宝弹框显示复制订单地址到其他浏览器支付 -->
    <component :is="isShowJumpPay ? 'JumpPay' : ''"
      :isShow="isShowJumpPay"
      :url="jumpPayUrl"
      :orderNo="params.orderNo"
      :accountUid="params.accountid"
      :projectUid="params.projectid"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Stepper,
  Divider,
  Button,
  Toast,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Picker,
  Popup,
  DatetimePicker,
  Area,
  Uploader,
  NumberKeyboard,
  Icon,
  Notify,
  Form,
  Loading,
  Overlay,
  CountDown,
  Lazyload
} from 'vant'

Vue.use(Button)
Vue.use(Toast)
Vue.use(Field)
Vue.use(CellGroup)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Area)
Vue.use(Uploader)
Vue.use(NumberKeyboard)
Vue.use(Stepper)
Vue.use(Icon)
Vue.use(Notify)
Vue.use(Form)
Vue.use(Loading)
Vue.use(Divider)
Vue.use(Overlay)
Vue.use(CountDown)
Vue.use(Lazyload)

import CusTitle from '@c/CusTitle'
import RichText from '@c/RichText'
import CopyRight from '@c/CopyRight'
import PaymentWay from '@c/PaymentWay'
import CusLoading from '@c/CusLoading'
import CusPayAgain from '@c/CusPayAgain'
import GoodForm from './comp/Form.vue'
import BookFooter from './comp/BookFooter.vue'
import BackBtn from '@c/BackBtn'

import { GetTotalOptions, GetFormOptions, CreateOrder } from '@a/js/api/booking.js'
import { QicukSort, ObjectDeepClone } from '@a/js/utils.js'
import apiObj from '@a/js/api.js'

import { SetWechatShare } from '@a/js/utils'
import { Base64 } from 'js-base64'
import wx from 'weixin-js-sdk'
import { GetVersionOption, GetWxshareConfig } from '@a/js/api/public'
import JumpPay from '@c/JumpPay.vue'

export default {
  name: 'Book',
  data() {
    return {
      params: {},
      apiObj,
      loading: true,
      currency: '￥',
      max_buy_quantity: 0,
      infos: {},
      payment: [],
      goodnum: 1,
      is_bottom_text: 0,
      bottom_text: '',
      // 表单配置
      formOptions: [],
      fieldsData: {},
      ispayment: false,
      isSubmit: false,
      userinfo: {},
      submiting: false,
      offline_pay_text: '',
      is_offline_pay_cert: true,
      isnopaid: false,
      waitOrder: '',
      waitPayway: '',
      waitPayMethod: '',
      is_submit_jump_url: 0,
      submit_jump_url: '',
      isShowJumpPay: false, // 微信内支付宝支付，显示复制链接
      jumpPayUrl: "" // 复制到浏览器打开的支付宝订单页面地址
    };
  },

  computed: {
    days() {
      return (new Date(this.infos.checkout).getTime() - new Date(this.infos.checkin).getTime()) / 86400000
    },
    program_env() {
      return window.location.host === 'c.banhuiyun.com' ? 'pro' : 'dev'
    }
  },
  components: {
    CusTitle,
    GoodForm,
    RichText,
    CopyRight,
    BookFooter,
    PaymentWay,
    CusLoading,
    CusPayAgain,
    BackBtn,
    JumpPay
  },

  methods: {
    // 获取参数信息
    GetParamsData() {
      return new Promise(resolve => {
        this.params = this.$route.params;
        resolve();
      });
    },
    // 获取本地数据
    initLocalData() {
      let local = this.$storeLocal.get('cbooking_good')
      if (local) {
        if (local.accountid == this.params.accountid && local.projectid == this.params.projectid && local.hotelid == this.params.hotelid && local.roomid == this.params.roomid && local.goodid == this.params.goodid) {
          // 展示信息，并获取表单配置
          this.infos = local
          // console.log(this.infos)
          this.wannaTotalOpt()
          this.wannaFormFields()
        } else {
          this.jumpToHome()
        }
      } else {
        // 跳转酒店预订首页
        this.jumpToHome()
      }
    },
    // 跳转酒店预订首页
    jumpToHome() {
      this.$router.push({
        name: "Home",
        params: {
          accountid: this.params.accountid,
          projectid: this.params.projectid,
          language: this.$i18n.locale
        }
      })
    },
    // 获取整体配置
    wannaTotalOpt() {
      let data = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        fields: [
          "currency",
          "theme",
          "max_buy_quantity",
          "is_bottom_text",
          "bottom_text",
          "payment",
          "is_offline_pay_cert",
          "offline_pay_text",
          "is_submit_jump_url",
          "submit_jump_url"
        ]
      }
      GetTotalOptions(data, this.$root.language).then(res => {
        // console.log(res.data)
        this.currency = res.data.currency
        this.max_buy_quantity = res.data.max_buy_quantity
        this.is_bottom_text = res.data.is_bottom_text
        this.bottom_text = res.data.bottom_text
        this.payment = res.data.payment
        this.offline_pay_text = res.data.offline_pay_text
        this.is_offline_pay_cert = res.data.is_offline_pay_cert ? true : false
        this.$root.isJump = res.data.is_submit_jump_url ? 1 : 0
        this.$root.jumpUrl = res.data.submit_jump_url ? res.data.submit_jump_url : ''
        this.initThemeOpt(res.data.theme)
      }).catch(() => { })
    },
    // 设置主体颜色
    initThemeOpt(info) {
      document.body.style.setProperty('--background', info.background)
      document.body.style.setProperty('--color', info.color)
    },
    // 查询表单字段信息
    wannaFormFields() {
      let data = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid
      }
      GetFormOptions(data, this.$root.language).then(res => {
        // console.log(res)
        this.fieldsData = res.data.fields
        this.GetFormOptionArr(res.data.fields).then(info => {
          this.SortFormHeader(info).then(arr => {
            this.formOptions = ObjectDeepClone(arr)
            // console.log(this.formOptions)
            this.loading = false
          })
        })
      }).catch(() => { })
    },
    // 获取表头配置数组
    GetFormOptionArr(data) {
      return new Promise((resolve) => {
        let tempArr = []
        Object.keys(data).map((item) => {
          tempArr.push(data[item])
        })
        resolve(tempArr)
      })
    },
    // 对表头数组进行排序
    SortFormHeader(data) {
      return new Promise((resolve) => {
        let sortedFormOption = QicukSort(data, 'form', 'field')
        resolve(sortedFormOption)
      })
    },

    // 点击订房
    wannaBookRoom() {
      // this.ispayment = true
      this.isSubmit = true
    },
    // 重置提交状态
    resetSubmitStatus() {
      this.isSubmit = false
    },
    // 表单数据校验成功
    formDataCheckFinish(infos) {
      this.userinfo = infos
      // console.log(this.userinfo)
      this.isSubmit = false
      // 弹起支付方式选择
      this.ispayment = true
    },
    // 取消支付方式选择
    closePaymentPicker() {
      this.ispayment = false
    },
    // 确认选择支付方式
    pickedPaymentWay(val, cert) {
      // console.log(val)
      this.ispayment = false
      this.wannaSubmitOrder(val, cert)
    },
    // 数据提交
    wannaSubmitOrder(way, cert) {
      let data = {
        req_type: 'BBooking',
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        app_name: this.$AppName,
        payment: way,
        offline_pay_cert: cert,
        form_data: this.userinfo,
        goods: [
          {
            product_uid: this.params.goodid,
            hotel_uid: this.params.hotelid,
            room_uid: this.params.roomid,
            goods_name: this.infos.hotel_name,
            goods_name_sec: this.infos.room_name,
            goods_name_thd: this.infos.good_name,
            quantity: this.goodnum
          }
        ],
        time_begin: this.infos.checkin,
        time_end: this.infos.checkout,
        extra: `${this.infos.type}|${this.infos.capacity}`
      }

      if (way.indexOf('wxpay') != -1) {
        this.judgeIsMiniProgran().then(() => {
          data.payment = 'wxpay_miniprogram'
        })
      }
      this.loading = true
      CreateOrder(data, this.$root.language).then(async res => {
        // console.log(res)
        if (res.code == '10001') {
          this.loading = false
          this.waitOrder = res.data.order_no
          this.waitPayway = res.data.payment
          this.waitPayMethod = res.data.payment_method
          this.isnopaid = true
        } else {
          let info = {
            accountid: this.params.accountid,
            projectid: this.params.projectid,
            orderid: res.data.order_no
          }
          this.$storeLocal.set('cbooking_order', info)
          if (data.payment.indexOf('offline') != -1) {
            if (this.is_submit_jump_url) {
              window.location.href = this.submit_jump_url
            } else {
              this.$router.push({
                name: 'Result',
                params: {
                  accountid: this.params.accountid,
                  projectid: this.params.projectid,
                  orderid: res.data.order_no,
                  language: this.$i18n.locale
                }
              })
            }
          } else if (data.payment.indexOf('wxpay') != -1) {

            this.judgeIsMiniProgran().then(() => {
              let return_url = ''
              if (this.is_submit_jump_url) {
                return_url = this.submit_jump_url
              } else {
                return_url = apiObj.VUE_APP_BASE_SERVE + 'booking/result/' + this.params.accountid + '/' + this.params.projectid + '/' + res.data.order_no + '/' + this.$i18n.locale
              }

              wx.miniProgram.navigateTo({
                url: '/pages/payment/index?req_type=BUnion&account_uid=' + this.params.accountid + '&project_uid=' + this.params.projectid + '&order_no=' + res.data.order_no + '&env=' + this.program_env + '&return_url=' + return_url,
                success: () => { },
                fail: () => { }
              })

            }).catch(() => {
              let apiurl = apiObj.VUE_APP_BASE_API + '/g/v1/pay_bhy/pay?req_type=BUnion&account_uid=' + this.params.accountid + '&project_uid=' + this.params.projectid + '&order_no=' + res.data.order_no + '&return_url='
              let return_url = ''
              if (this.is_submit_jump_url) {
                return_url = this.submit_jump_url
              } else {
                return_url = apiObj.VUE_APP_BASE_SERVE + 'booking/result/' + this.params.accountid + '/' + this.params.projectid + '/' + res.data.order_no + '/' + this.$i18n.locale
              }
              let paid_url = apiurl + return_url
              window.location.href = paid_url
            })
          } else {

            let apiurl = apiObj.VUE_APP_BASE_API + '/g/v1/pay_bhy/pay?req_type=BUnion&account_uid=' + this.params.accountid + '&project_uid=' + this.params.projectid + '&order_no=' + res.data.order_no + '&return_url='

            let return_url = ''

            if (this.is_submit_jump_url) {

              return_url = this.submit_jump_url

            } else {

              return_url = apiObj.VUE_APP_BASE_SERVE + 'booking/result/' + this.params.accountid + '/' + this.params.projectid + '/' + res.data.order_no + '/' + this.$i18n.locale

            }

            // 支付宝支付 & 微信内 & ios 系统
            if (data.payment.indexOf('alipay') != -1 &&
                this.judgeIsWeiXin() &&
                await this.JudgeTerminalType() === 'ios'
              ) {

                this.params.orderNo = res.data.order_no
                this.jumpPayUrl = apiurl + return_url

                this.loading = false

                // 显示复制链接到浏览器支付
                this.isShowJumpPay = true
              }
              else {
                // 支付宝（非微信内 & 非 ios） or paypal 跳转支付
                window.location.href = apiurl + return_url
              }
          }
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 判断是否小程序内打开
    judgeIsMiniProgran() {
      return new Promise((resolve, reject) => {
        wx.miniProgram.getEnv(res => {
          // alert(JSON.stringify(res))
          if (res.miniprogram) {
            resolve()
          }
          reject()
        })
        reject()
      })
    },
    // 关闭弹框
    closeDialog() {
      this.isnopaid = false
    },
    // 初始化版权信息
    initVersionOption() {
      let data = {
        account_uid: this.params.accountid,
        app_name: 'version',
        type: 4
      }
      GetVersionOption(data).then(res => {
        this.$root.isVersion = res.data.is_version
      }).catch(() => { })
    },
    // 页面初始化获取微信分享配置
    InitWxShareConfig() {
      let href = window.location.href.split('#')[0]
      let resdata = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        app_name: this.$AppName,
        url: Base64.encode(href),
      }
      GetWxshareConfig(resdata)
        .then((res) => {
          // console.log(res)
          if (res.data.config.appId) {
            let imgUrl = ''
            if (res.data.info.img.length > 0) {
              imgUrl = apiObj.VUE_APP_BASE_CDN + res.data.info.img
            }
            SetWechatShare(wx, res.data, href, imgUrl)
          }
        })
        .catch(() => { })
    },
    // 判断终端类型
    JudgeTerminalType() {
      return new Promise((resolve) => {

        const uAgent = navigator.userAgent

        if (/(iPhone|iPad|iPod|iOS)/i.test(uAgent)) {
          resolve("ios")
        }
        else if (/(Android)/i.test(uAgent)) {
          resolve("android")
        }
        else {
          resolve("other")
        }
      })
    },
    // 判断是否微信浏览器
    judgeIsWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      // console.log(ua);//mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },
    alipayInWechat(orderNo, jumpPayUrl) {
      this.params.orderNo = orderNo
      this.jumpPayUrl = jumpPayUrl
      this.loading = false
      this.isnopaid = false
      this.isShowJumpPay = true
    }
  },

  mounted() {
    this.GetParamsData().then(() => {
      this.initVersionOption()
      this.InitWxShareConfig()
      this.initLocalData()
    })
  },
}
</script>
<style lang='less' scoped>
.book_wrap {
  background: #fff;
  margin-bottom: 60px;
  // 商品
  .product_info_wrap {
    padding: 15px;
    padding-bottom: 0px;
    overflow: hidden;
    .product_info_body {
      display: flex;
      .prod_left_wrap {
        width: 120px;
        height: 80px;
        border-radius: 4px;
        overflow: hidden;
        background-size: cover;
        background-repeat: no-repeat;
        margin-right: 15px;
      }
      .prod_right_wrap {
        flex: 1;
        width: 0;
        .room_name,
        .hotel_name {
          font-size: 18px;
          font-weight: 700;
          letter-spacing: 0.01em;
          line-height: 26px;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 2px;
        }
        .hotel_name {
          font-size: 14px;
          line-height: 20px;
        }
        .prod_right_footer {
          display: flex;
          .prod_footer_left {
            margin-right: 15px;
            .check_time {
              font-size: 12px;
              line-height: 18px;
              letter-spacing: 0.01em;
            }
          }
          .prod_footer_right {
            flex: 1;
            width: 0;
            .check_days,
            .good_name {
              font-size: 12px;
              line-height: 18px;
              font-weight: 700;
              letter-spacing: 0.01em;
              text-align: center;
            }
            .good_name {
              font-weight: normal;
              overflow: hidden;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: 2px;
            }
          }
        }
      }
    }
  }
  // 数量选择
  .stepper_wrap {
    display: flex;
    margin-top: 20px;
    .stepper_text {
      flex: 1;
      font-size: 18px;
      line-height: 26px;
      font-weight: 700;
      &::before {
        content: " ";
        position: relative;
        width: 4px;
        height: 20px;
        display: inline-block;
        border-radius: 2px;
        background: var(--background);
        top: 4px;
        margin: 0 8px 0 0;
      }
    }
  }
  .divider_wrap {
    padding: 0 15px;
  }
  .sale_intro_wrap {
    padding: 15px;
  }
  // 表单内容
  .form_info_wrap {
    min-height: calc(~"100vh - 340px");
  }
}
</style>